import React from 'react';

import AuthPageBase from 'components/AuthPageBase/AuthPageBase';
import ForgotPasswordForm from '../containers/ForgotPasswordFormContainer';

const ForgotPasswordPage = () => <AuthPageBase form={<ForgotPasswordForm/>}/>;

export default ForgotPasswordPage;